import React, { memo } from 'react';
import cn from 'classnames';

import { useTranslation } from 'providers/GILT.provider';

import CN from './TagName.module.scss';

const TagName = ({ onChange, name, darkTheme }) => {
  const { t } = useTranslation();

  return (
    <div data-bem="TagName" className={cn({ [CN.container]: true, [CN.dark]: darkTheme })}>
      <span>{t('clientTags.tagName')}</span>
      <input
        name="name"
        id="name"
        className={CN.inputDefault}
        type="text"
        onChange={onChange}
        value={name}
        placeholder=""
        maxLength="30"
      />
    </div>
  );
};

export default memo(TagName);
